import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { search }, palette }: ComposedTheme) => ({
  clearSearch: {
    marginLeft: 4,
  },
  currentSearch: {
    marginLeft: 4,
    color: palette.text.dark,
  },
  form: {
    position: 'relative',
    '& label': {
      margin: 0,
    },
    '& input': {
      paddingRight: 50,
    },
    marginRight: 4,
    width: '100%',
  },
  searchIcon: {
    position: 'absolute',
    right: 4,
    top: 4,
    padding: 4,
  },
  clearSearchInputIcon: {
    position: 'absolute',
    right: 32,
    top: 4,
    padding: 4,
  },
  resultsForWrapper: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
  },
  resultsForText: {
    color: palette.text.midGray,
    margin: 0,
    flex: 2,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  wrapper: {
    fontFamily: search.text.font.fontFamily,
    fontSize: search.text.font.fontSize,
    fontWeight: search.text.font.fontWeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 320,
    minWidth: 200,
  },
});

export default createUseStyles(styles);
